export default () => {
  const pointers = [...document.querySelectorAll('.js-product-feature-pointer')]
  const features = [...document.querySelectorAll('.js-product-feature')]
  if (!pointers.length) return

  const pointerActive = 'c-product-feature__pointer--active'
  const featureActive = 'c-product-feature__item--active'

  let counter = 0
  let interval = null

  const start = () => {
    interval = setInterval(() => {
      clearAll()
      pointers[counter].classList.add(pointerActive)
      features[counter].classList.add(featureActive)
      counter < pointers.length - 1 ? counter++ : counter = 0
    }, 2000)
  }

  start()

  pointers.forEach(pointer => {
    pointer.addEventListener('mouseenter', function () {
      clearInterval(interval)
      clearAll()
      const { target } = this.dataset
      document.getElementById(target).classList.add(featureActive)
    })
    pointer.addEventListener('mouseleave', function () {
      clearAll()
      start()
    })
  })

  features.forEach(feature => {
    feature.addEventListener('mouseenter', function () {
      clearInterval(interval)
      clearAll()
      const { target } = this.dataset
      document.getElementById(target).classList.add(pointerActive)
    })
    feature.addEventListener('mouseleave', function () {
      clearAll()
      start()
    })
  })

  const clearAll = () => {
    pointers.forEach(pointer => pointer.classList.remove('c-product-feature__pointer--active'))
    features.forEach(feature => feature.classList.remove('c-product-feature__item--active'))
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/ProductFeatures.js